
import {values, isNumber} from 'lodash'


function sumOfTwoMaybe(a = 0, b = 0) { return (a||0) + (b||0) }

function eur2yuan(e, rate) { return isNumber(e) ? e * rate : 0 }

export function getPrice(price, persons, extras) {
  return values(extras).map(extra => extra.price.perGroup ? extra.price.general : extra.price.general * persons).reduce(sumOfTwoMaybe, persons * price.general)
}

export function getYuanPrice(price, persons, extras, rate) {
  return eur2yuan(getPrice(price, persons, extras), rate)
}



// WEBPACK FOOTER //
// ./src/app/catalogo/CatalogoTools.js